/**
 * Application-wide configuration.
 *
 * auth / cache — MSAL PublicClientApplication constructor options.
 * copilot / claude / jira — Per-agent Copilot Studio connection settings consumed by CopilotChat.
 *   Each agent entry also carries UI-level properties (botAvatar, quickQuestions) so that
 *   CopilotChat can render agent-specific content without any hardcoded conditionals.
 */
export const settings = {

  version: "1.0.",
  ticketBaseUrl: "https://jiratst.lnw.com/browse/",

  auth: {
    clientId: "33f65fc6-ef5e-44e2-a51d-17bfa5a45e85",
    authority: "https://login.microsoftonline.com/a3afe9fa-a6af-4049-b0e3-05a64a7adb77",
    redirectUri: window.location.origin + "/login/callback",
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
    scopes: ["openid", "profile", "email", "offline_access", "ProfilePhoto.Read.All", "Sites.Read.All", "User.Read", "User.Read.All", "User.ReadBasic.All", "api://default/.default"]
  },

  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },

  /** PeopleHub HR assistant agent */
  copilot: {
    appClientId: "33f65fc6-ef5e-44e2-a51d-17bfa5a45e85",
    tenantId: "a3afe9fa-a6af-4049-b0e3-05a64a7adb77",
    environmentId: "Default-a3afe9fa-a6af-4049-b0e3-05a64a7adb77",
    agentIdentifier: "auto_agent_LqM_x",
    directConnectUrl: "https://defaulta3afe9faa6af4049b0e305a64a7adb.77.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/auto_agent_LqM_x/conversations?api-version=2022-03-01-preview",
    botAvatar: "/images/goldfish-1.png",
    quickQuestions: [
      { label: "How do I log into Workday?", text: "How do I log into Workday and what do I do if I can't access it?" },
      { label: "Request a proof of employment letter", text: "How do I request a proof of employment or employment verification letter?" },
      { label: "Where can I find my pay information?", text: "How do I access my paystubs and other payroll documents?" },
      { label: "Add dependents to my benefits", text: "How do I add dependents or a spouse to my benefits?" },
      { label: "Request maternity or paternity leave", text: "How do I request maternity or paternity leave?" },
    ],
  },

  /** Goldie — Claude-powered general-purpose agent */
  claude: {
    appClientId: "33f65fc6-ef5e-44e2-a51d-17bfa5a45e85",
    tenantId: "a3afe9fa-a6af-4049-b0e3-05a64a7adb77",
    environmentId: "Default-a3afe9fa-a6af-4049-b0e3-05a64a7adb77",
    agentIdentifier: "copilots_header_89fca", //"cr937_agent1aNnwb8",
    directConnectUrl: "https://defaulta3afe9faa6af4049b0e305a64a7adb.77.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/copilots_header_89fca/conversations?api-version=2022-03-01-preview",
    // directConnectUrl: "https://defaulta3afe9faa6af4049b0e305a64a7adb.77.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/cr937_agent1aNnwb8/conversations?api-version=2022-03-01-preview",
    botAvatar: "/images/goldfish-1.png",
    quickQuestions: [
      { label: "How do I log into Workday?", text: "How do I log into Workday and what do I do if I can't access it?" },
      { label: "Request a proof of employment letter", text: "How do I request a proof of employment or employment verification letter?" },
      { label: "Where can I find my pay information?", text: "How do I access my paystubs and other payroll documents?" },
      { label: "Add dependents to my benefits", text: "How do I add dependents or a spouse to my benefits?" },
      { label: "Request maternity or paternity leave", text: "How do I request maternity or paternity leave?" },
    ],
  },

  /** ITSD — IT service desk agent backed by Jira */
  jira: {
    appClientId: "33f65fc6-ef5e-44e2-a51d-17bfa5a45e85",
    tenantId: "a3afe9fa-a6af-4049-b0e3-05a64a7adb77",
    environmentId: "Default-a3afe9fa-a6af-4049-b0e3-05a64a7adb77",
    agentIdentifier: "cre24_ITSDAgentDev",
    directConnectUrl: "https://5a057da6bc67ecc7a89ec6bac1ad82.12.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/cre24_ITSDAgentDev/conversations?api-version=2022-03-01-preview",
    // directConnectUrl: "https://2e6b1ce46652e85dba057d111ef846.15.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/cat_ITMasterAgent1/conversations?api-version=2022-03-01-preview",
    botAvatar: "/images/itsd-icon_.png",
    quickQuestions: [
      { label: "How can I reset my network password?", text: "How can I reset my network password?" },
      { label: "How to setup VPN for LNW Creators?", text: "How To – Setup VPN for LNW Creators?" },
      { label: "How do I get access to Jira and Confluence?", text: "How do I get access to Jira and Confluence?" },
      { label: "What security policies should I be aware of?", text: "What security policies should I be aware of?" },
    ],
  },

  Goldie_Dev: {
    appClientId: '33f65fc6-ef5e-44e2-a51d-17bfa5a45e85',        
    tenantId: 'a3afe9fa-a6af-4049-b0e3-05a64a7adb77',
    environmentId: 'Default-a3afe9fa-a6af-4049-b0e3-05a64a7adb77',
    agentIdentifier: 'cre24_timeAgentPoc', // 'copilots_header_89fca', // 'copilots_header_89fca',
    directConnectUrl: 'https://5a057da6bc67ecc7a89ec6bac1ad82.12.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/cre24_timeAgentPoc/conversations?api-version=2022-03-01-preview',
    // directConnectUrl: 'https://b0a6dfecdbade09ba5664f4f3c10a3.05.environment.api.powerplatform.com/copilotstudio/dataverse-backed/authenticated/bots/cre24_timeAgentPoc/conversations?api-version=2022-03-01-preview',
    botAvatar: "/images/ts-icon_.png",
    quickQuestions: [
      { label: "How can I reset my network password?", text: "How can I reset my network password?" },
      { label: "How to setup VPN for LNW Creators?", text: "How To – Setup VPN for LNW Creators?" },
      { label: "How do I get access to Jira and Confluence?", text: "How do I get access to Jira and Confluence?" },
      { label: "What security policies should I be aware of?", text: "What security policies should I be aware of?" },
    ],
}
};

/** MSAL login scopes used when initiating an interactive auth flow. */
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
